import { render } from "./Newsletter.vue?vue&type=template&id=38022a0d&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=38022a0d&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38022a0d"]])

export default __exports__